/*Bug #603 - Create a common component for Address fields - Author Jithin Kuriakose on 05Sept2021*/
import { Col } from "components";

interface Props {
    className?: React.CSSProperties | String;
    label?: String;
}

const CommonInputLabel = (props: Props) => {
    return (
        <Col md={12} lg={12} className="newFormLblContainer">
            <div className="newFormNameLbl">
                <label>{props?.label ? props.label : ""}</label>
            </div>
            <div className="newFormLineWrapper">
                <div className="newFormHzline"></div>
            </div>
        </Col>
    );
};

export default CommonInputLabel;
/*End Bug #603*/